import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import FeeConfigureIndex from '@routes/Home/routes/AdminPortal/routes/FeeConfiguration/routes/FeeConfigureIndex';
import FeeStructureConfigure from '@routes/Home/routes/AdminPortal/routes/FeeConfiguration/routes/FeeStructureConfigure';
import FeeConcession from '@routes/Home/routes/AdminPortal/routes/FeeConfiguration/routes/FeeConcession';
import PaymentGatewayIntegration from '@routes/Home/routes/AdminPortal/routes/FeeConfiguration/routes/PaymentGatewayIntegration';

const FeeConfigurationLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'FeeConfiguration' */ './components/FeeConfigureLayout'
		)
);

export default (store) => {
	return {
		path: 'fee-configuration',
		element: <AsyncLoading component={<FeeConfigurationLazy />} />,
		children: [
			FeeConfigureIndex(store),
			FeeStructureConfigure(store),
			FeeConcession(store),
			PaymentGatewayIntegration(store),
		],
	};
};
